import type {Sector} from "crqlar-react-common/dist/models/sector/sector.model";
import {useAuthorizedViaAdmin} from "crqlar-react-common/dist/utils/hooks/admin/useAuthorizedViaAdmin";
import {useCurrentAppId} from "crqlar-react-common/dist/utils/hooks/app/useOrganizationApps";
import {useLocalize} from "crqlar-react-common/dist/utils/text.util";
import type {ReactElement} from "react";
import {useLocation} from "react-router-dom";
import {useReservationsState} from "../../store/reservations.reducer";
import {PageShell, type TabRoute} from "../layout/PageShell";
import RestaurantDailyList from "../dailyLists/RestaurantDailyList";
import RestaurantInsightsTab from "../insights/RestaurantInsightsTab";
import RestaurantArrivalsList from "./lists/RestaurantArrivalsList";
import RestaurantReservationList from "./lists/RestaurantReservationList";
import {ReservationCalendar} from "./ReservationCalendar";
import {RestaurantFloorplanTab} from "./RestaurantFloorplanTab";

interface Props {
    appName: string;
    icon: ReactElement;
    tabPath: (tab: string) => string;
    sector: Sector;
}

export default function Restaurant({appName, icon, tabPath, sector}: Props) {
    const {t, localize} = useLocalize();
    const appId = useCurrentAppId();
    const {pathname} = useLocation();
    const {selectedResourceSingle} = useReservationsState(appId);
    const isAuthorizedViaAdmin = useAuthorizedViaAdmin();
    const floorplanPath = tabPath("floorplan");
    const floorplanRestaurantName = pathname === floorplanPath
        ? localize(selectedResourceSingle?.nameLocalized) || selectedResourceSingle?.name
        : undefined;

    const tabs: TabRoute[] = [
        {
            path: tabPath("daily"),
            label: t("Daily List"),
            render: () => sector.id ? <RestaurantDailyList sectorId={sector.id}/> : null,
        },
        {
            path: tabPath("calendar"),
            label: t("Calendar"),
            render: () => sector.id ? <ReservationCalendar sector={sector}/> : null,
        },
        {
            path: floorplanPath,
            label: t("Floor plan"),
            render: () => sector.id ? <RestaurantFloorplanTab sector={sector}/> : null,
        },
        {
            path: tabPath("list"),
            label: t("List"),
            render: () => sector.id ? <RestaurantReservationList sectorId={sector.id}/> : null,
        },
        {
            path: tabPath("halfboard"),
            label: t("Arrivals"),
            render: () => sector.id ? <RestaurantArrivalsList sector={sector}/> : null,
        },
        // ...(isAuthorizedViaAdmin
        //     ? [{
        //         path: tabPath("insights"),
        //         label: t("Insights"),
        //         render: () => <RestaurantInsightsTab sector={sector}/>,
        //     }]
        //     : []),
    ];

    return (
        <PageShell
            icon={icon}
            title={appName}
            documentTitle={floorplanRestaurantName || appName}
            tabs={tabs}
        />
    );
}
